<div class="max-w-6xl mx-auto">

  <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
    <h1 class="text-3xl font-bold mb-2">Gérer les prédictions</h1>
    <p class="text-gray-600">Ajouter, modifier et supprimer des prédictions</p>
  </div>

  <div class="bg-white shadow rounded-lg p-8">
    <h2 class="text-xl font-semibold mb-6 text-center">Ajouter une prédiction</h2>
    <app-prediction-form (formSubmit)="onCreate($event)" [teams]="teams()" [competitions]="competitions()"
      [sports]="sports()">
    </app-prediction-form>

    <div *ngIf="customErrors.dateError" class="text-red-500 text-sm text-center">
      La date ne peut pas être dans le passé.
    </div>
    <div *ngIf="customErrors.isEqualTeams" class="text-red-500 text-sm text-center">
      Les équipes ne doivent pas être les mêmes
    </div>
    <app-manage-predictions-table></app-manage-predictions-table>
  </div>
